import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { DateWithoutUTCFormat } from '@maverick/utils';
import { SourceApps } from '@maverick/entity';
import { createApiClient } from './client';

interface GetRestaurantCalendarParams {
    restaurantId: number;
}

interface GetRestaurantParams {
    restaurantId: number;
}

export class RestaurantService {
    private readonly apiClient;

    constructor(sourceApp: SourceApps) {
        this.apiClient = createApiClient(sourceApp);
    }

    async getRestaurantCalendar({ restaurantId }: GetRestaurantCalendarParams): Promise<RestResponse> {
        const today = DateWithoutUTCFormat(new Date());
        const plus6days: Date = new Date();
        plus6days.setDate(today.getDate() + 6);

        const convertDateToString = (date: Date) => {
            return date.toISOString().slice(0, 10).replaceAll('-', '');
        };

        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `/v1.1/restaurants/${restaurantId}/calendars?from=${convertDateToString(
                today
            )}&to=${convertDateToString(plus6days)}`,
        });

        return this.apiClient.ExecuteRequest(request);
    }

    async getRestaurant({ restaurantId }: GetRestaurantParams): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `/v1.1/restaurants/${restaurantId}`,
            headers: {
                'x-mav-cache': 900,
            },
        });

        return this.apiClient.ExecuteRequest(request);
    }
}
